<div class="signup-page">
  <!-- Fond animé avec particules -->
  <div class="background-animation">
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
      <div class="shape shape-5"></div>
      <div class="shape shape-6"></div>
    </div>
  </div>

  <!-- Container principal avec effet glassmorphism -->
  <div class="signup-container" [class.shake]="errorMessage && !showResendEmailOption">
    <!-- Section Logo avec animation -->
    <div class="logo-section">
      <a routerLink="/login" class="logo-link">
        <div class="logo-wrapper" [class.pulse]="isLoading">
          <img 
            src="../../../assets/icon-vendeur-transparent-01.png" 
            alt="Vendeur.site Logo" 
            class="logo-icon"
          >
          <div class="logo-glow"></div>
        </div>
      </a>
      <img 
        src="../../../assets/Vendeur-site-smallversion2.png" 
        alt="Vendeur.site" 
        class="logo-text"
      >
    </div>

    <!-- Titre et progression -->
    <div class="welcome-section">
      <h1 class="title">Créer un compte</h1>
      <p class="subtitle">Rejoignez la communauté des vendeurs</p>
    </div>

    <!-- Boutons OAuth en haut -->
    <div class="oauth-section">
      <button type="button" class="btn-oauth btn-codincloud" (click)="signupWithCodinCloud()">
        <div class="btn-oauth-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
          </svg>
        </div>
        <span>S'inscrire avec CodinCloud SSO</span>
        <div class="btn-shine"></div>
      </button>

      <div class="social-buttons">
        <button type="button" class="btn-oauth btn-facebook" (click)="signupWithFacebook()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
          <span>Facebook</span>
        </button>
        <button type="button" class="btn-oauth btn-google" (click)="signupWithGoogle()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span>Google</span>
        </button>
      </div>
    </div>

    <!-- Séparateur -->
    <div class="divider">
      <span>ou avec votre email</span>
    </div>

    <!-- Formulaire d'inscription -->
    <form [formGroup]="signupForm" (ngSubmit)="submitSignup()" class="signup-form" novalidate>
      <!-- Section Informations personnelles -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <h3>Informations personnelles</h3>
        </div>

        <div class="form-row">
          <div class="input-group" [class.focused]="focusedField === 'fullname'" [class.has-value]="signupForm.get('fullname')?.value" [class.has-error]="signupForm.get('fullname')?.invalid && signupForm.get('fullname')?.touched">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <input 
              type="text" 
              formControlName="fullname" 
              placeholder=" "
              autocomplete="name"
              (focus)="focusedField = 'fullname'"
              (blur)="focusedField = ''"
            >
            <label>Nom complet</label>
            <div class="input-highlight"></div>
          </div>

          <div class="input-group" [class.focused]="focusedField === 'username'" [class.has-value]="signupForm.get('username')?.value" [class.has-error]="signupForm.get('username')?.invalid && signupForm.get('username')?.touched">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M14.31 8a4 4 0 0 0-5.24 5.24"/>
                <line x1="2.41" y1="2.41" x2="21.59" y2="21.59"/>
              </svg>
            </div>
            <input 
              type="text" 
              formControlName="username" 
              placeholder=" "
              autocomplete="username"
              (focus)="focusedField = 'username'"
              (blur)="focusedField = ''"
            >
            <label>Nom d'utilisateur</label>
            <div class="input-highlight"></div>
          </div>
        </div>
        <div class="field-error" *ngIf="signupForm.get('username')?.hasError('minlength') && signupForm.get('username')?.touched">
          Au moins 3 caractères requis
        </div>
      </div>

      <!-- Section Contact -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          </div>
          <h3>Contact</h3>
        </div>

        <div class="form-row">
          <div class="input-group" [class.focused]="focusedField === 'email'" [class.has-value]="signupForm.get('email')?.value" [class.has-error]="signupForm.get('email')?.invalid && signupForm.get('email')?.touched">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <input 
              type="email" 
              formControlName="email" 
              placeholder=" "
              autocomplete="email"
              (focus)="focusedField = 'email'"
              (blur)="focusedField = ''"
            >
            <label>Adresse email</label>
            <div class="input-highlight"></div>
          </div>

          <div class="input-group" [class.focused]="focusedField === 'verify_email'" [class.has-value]="signupForm.get('verify_email')?.value" [class.has-error]="(signupForm.get('verify_email')?.invalid || signupForm.hasError('emailMismatch')) && signupForm.get('verify_email')?.touched">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
            </div>
            <input 
              type="email" 
              formControlName="verify_email" 
              placeholder=" "
              autocomplete="email"
              (focus)="focusedField = 'verify_email'"
              (blur)="focusedField = ''"
            >
            <label>Confirmer l'email</label>
            <div class="input-highlight"></div>
          </div>
        </div>
        <div class="field-error" *ngIf="signupForm.hasError('emailMismatch') && signupForm.get('verify_email')?.touched">
          Les emails ne correspondent pas
        </div>

        <div class="form-row single">
          <div class="input-group" [class.focused]="focusedField === 'phone'" [class.has-value]="signupForm.get('phone')?.value" [class.has-error]="signupForm.get('phone')?.invalid && signupForm.get('phone')?.touched">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
            </div>
            <input 
              type="tel" 
              formControlName="phone" 
              placeholder=" "
              autocomplete="tel"
              (focus)="focusedField = 'phone'"
              (blur)="focusedField = ''"
            >
            <label>Numéro de téléphone</label>
            <div class="input-highlight"></div>
          </div>
        </div>
      </div>

      <!-- Section Sécurité -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <h3>Sécurité</h3>
        </div>

        <div class="form-row">
          <div class="input-group" [class.focused]="focusedField === 'password'" [class.has-value]="signupForm.get('password')?.value" [class.has-error]="signupForm.get('password')?.invalid && signupForm.get('password')?.touched">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <input 
              [type]="showPassword ? 'text' : 'password'" 
              formControlName="password" 
              placeholder=" "
              autocomplete="new-password"
              (focus)="focusedField = 'password'"
              (blur)="focusedField = ''"
            >
            <label>Mot de passe</label>
            <button type="button" class="password-toggle" (click)="showPassword = !showPassword">
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
            <div class="input-highlight"></div>
          </div>

          <div class="input-group" [class.focused]="focusedField === 'confirmPassword'" [class.has-value]="signupForm.get('confirmPassword')?.value" [class.has-error]="(signupForm.get('confirmPassword')?.invalid || signupForm.hasError('passwordMismatch')) && signupForm.get('confirmPassword')?.touched">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <input 
              [type]="showConfirmPassword ? 'text' : 'password'" 
              formControlName="confirmPassword" 
              placeholder=" "
              autocomplete="new-password"
              (focus)="focusedField = 'confirmPassword'"
              (blur)="focusedField = ''"
            >
            <label>Confirmer le mot de passe</label>
            <button type="button" class="password-toggle" (click)="showConfirmPassword = !showConfirmPassword">
              <svg *ngIf="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
            <div class="input-highlight"></div>
          </div>
        </div>
        <div class="field-error" *ngIf="signupForm.hasError('passwordMismatch') && signupForm.get('confirmPassword')?.touched">
          Les mots de passe ne correspondent pas
        </div>

        <!-- Indicateur de force du mot de passe -->
        <div class="password-strength" *ngIf="signupForm.get('password')?.value">
          <div class="strength-bar">
            <div class="strength-fill" [style.width]="passwordStrength + '%'" [class.weak]="passwordStrength < 33" [class.medium]="passwordStrength >= 33 && passwordStrength < 66" [class.strong]="passwordStrength >= 66"></div>
          </div>
          <span class="strength-text" [class.weak]="passwordStrength < 33" [class.medium]="passwordStrength >= 33 && passwordStrength < 66" [class.strong]="passwordStrength >= 66">
            {{ passwordStrength < 33 ? 'Faible' : (passwordStrength < 66 ? 'Moyen' : 'Fort') }}
          </span>
        </div>

        <!-- Question de sécurité -->
        <div class="form-row single">
          <div class="select-group" [class.focused]="focusedField === 'security_question'" [class.has-value]="signupForm.get('security_question')?.value">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <select 
              formControlName="security_question"
              (focus)="focusedField = 'security_question'"
              (blur)="focusedField = ''"
            >
              <option value="" disabled selected>Choisir une question de sécurité</option>
              <option value="Quel est le nom de votre premier animal de compagnie ?">Nom de votre premier animal ?</option>
              <option value="Quel était le nom de votre école primaire ?">Nom de votre école primaire ?</option>
              <option value="Dans quelle ville êtes-vous né(e) ?">Ville de naissance ?</option>
              <option value="Quel est le nom de jeune fille de votre mère ?">Nom de jeune fille de votre mère ?</option>
              <option value="Quel est votre plat préféré ?">Votre plat préféré ?</option>
            </select>
            <div class="select-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="form-row single">
          <div class="input-group" [class.focused]="focusedField === 'security_answer'" [class.has-value]="signupForm.get('security_answer')?.value">
            <div class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <input 
              type="text" 
              formControlName="security_answer" 
              placeholder=" "
              (focus)="focusedField = 'security_answer'"
              (blur)="focusedField = ''"
            >
            <label>Réponse à la question</label>
            <div class="input-highlight"></div>
          </div>
        </div>
      </div>

      <!-- Bouton de soumission -->
      <button 
        type="submit" 
        class="btn-primary" 
        [disabled]="!signupForm.valid || isLoading"
        [class.loading]="isLoading"
      >
        <span class="btn-content" *ngIf="!isLoading">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="8.5" cy="7" r="4"/>
            <line x1="20" y1="8" x2="20" y2="14"/>
            <line x1="23" y1="11" x2="17" y2="11"/>
          </svg>
          Créer mon compte
        </span>
        <span class="loader" *ngIf="isLoading">
          <span class="loader-dot"></span>
          <span class="loader-dot"></span>
          <span class="loader-dot"></span>
        </span>
      </button>
    </form>

    <!-- Footer -->
    <div class="signup-footer">
      <p>Déjà un compte ? <a routerLink="/login">Se connecter</a></p>
    </div>
  </div>

  <!-- Modal d'erreur -->
  <div class="error-modal-overlay" *ngIf="errorMessage" (click)="closeErrorModal($event)">
    <div class="error-modal" [@slideIn]>
      <div class="error-modal-header">
        <div class="error-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <h3>Erreur d'inscription</h3>
        <button type="button" class="close-modal" (click)="errorMessage = null">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div class="error-modal-content">
        <p [innerHTML]="formattedErrorMessage"></p>
      </div>
      <div class="error-modal-actions">
        <button type="button" class="btn-secondary" (click)="errorMessage = null" *ngIf="!showResendEmailOption">
          Compris
        </button>
        <button 
          type="button" 
          class="btn-primary" 
          (click)="resendVerificationEmail()" 
          *ngIf="showResendEmailOption"
          [disabled]="isResendingEmail"
        >
          <span *ngIf="!isResendingEmail">Renvoyer l'email</span>
          <span *ngIf="isResendingEmail">Envoi en cours...</span>
        </button>
        <button type="button" class="btn-secondary" (click)="errorMessage = null; showResendEmailOption = false" *ngIf="showResendEmailOption">
          Fermer
        </button>
      </div>
    </div>
  </div>

  <!-- Version badge -->
  <div class="version-badge">
    <span>Vendeur.site v2.0</span>
  </div>
</div>
